import { COLUMN_ACTION, COLUMN_ADDRESS, COLUMN_DETAILS, COLUMN_DISPLAY_NAME, COLUMN_NAME, COLUMN_PERMISSIONS, COLUMN_PORT_NUM } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

const EmailAccountColumns: TableColumn[] = [
    {
        heading: "Email Account",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "accName",
        sortDirection: "asc",
        active: true,
        translationKey: "emailAccount",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Default",
        accessor: "accDefault",
        isNumeric: false,
        id: 1,
        sortByName: "accDefault",
        sortDirection: "asc",
        active: true,
        translationKey: "default",
        columnId: COLUMN_DETAILS,
    },
    {
        heading: "Outgoing Server",
        accessor: "outgoingServer",
        isNumeric: false,
        id: 2,
        sortByName: "outgoingServer",
        sortDirection: "asc",
        active: true,
        translationKey: "outgoingServer",
        columnId: COLUMN_ADDRESS
    },
    {
        heading: "Username",
        accessor: "username",
        isNumeric: false,
        id: 3,
        sortByName: "username",
        sortDirection: "asc",
        active: true,
        translationKey: "username",
        columnId: COLUMN_DISPLAY_NAME
    },
    {
        heading: "Port Number",
        accessor: "portNumber",
        isNumeric: false,
        id: 4,
        sortByName: "portNumber",
        sortDirection: "asc",
        active: true,
        translationKey: "portNumber",
        columnId: COLUMN_PORT_NUM
    },
    {
        heading: "Authentication",
        accessor: "authEnabled",
        isNumeric: false,
        id: 5,
        sortByName: "authEnabled",
        sortDirection: "asc",
        active: true,
        translationKey: "authentication",
        columnId: COLUMN_ACTION
    },
    {
        heading: "TLS",
        accessor: "sslEnabled",
        isNumeric: false,
        id: 6,
        sortByName: "sslEnabled",
        sortDirection: "asc",
        active: true,
        translationKey: "tls",
        columnId: COLUMN_PERMISSIONS
    }
];

export default EmailAccountColumns;
